/**
 * Calculates the duration elapsed since a given start date and returns it as a string.
 * @param {Date} startDate - The start date to calculate the duration from.
 * @returns {string} A string describing the elapsed duration in years, months, days, hours, and minutes.
 */
export function displayPastDuration(startDate) {
  const msPerSecond = 1000;
  const msPerMinute = msPerSecond * 60;
  const msPerHour = msPerMinute * 60;
  const msPerDay = msPerHour * 24;
  const msPerMonth = msPerDay * 30.44; // Average month length
  const msPerYear = msPerDay * 365.25; // Average year length

  const timeElapsed = new Date() - startDate;
  const years = Math.floor(timeElapsed / msPerYear);
  const months = Math.floor((timeElapsed % msPerYear) / msPerMonth);
  const days = Math.floor((timeElapsed % msPerMonth) / msPerDay);
  const hours = Math.floor((timeElapsed % msPerDay) / msPerHour);
  const minutes = Math.floor((timeElapsed % msPerHour) / msPerMinute);

  let durationString = '';
  if (years > 0)
    durationString += years + ' année ' + (years > 1 ? 's ' : ' ') + ' ';
  if (months > 0) durationString += months + ' mois ';
  if (days > 0)
    durationString += days + ' jour' + (days > 1 ? 's ' : ' ') + ' ';
  if (days < 1) {
    if (hours > 0)
      durationString += hours + ' heure' + (hours > 1 ? 's ' : ' ') + ' ';
    if (minutes > 0)
      durationString += minutes + ' minute' + (minutes > 1 ? 's ' : ' ') + ' ';
  }

  return durationString;
}
